import React from 'react';
import {
  DialogTitle,
  DialogContent,
  DialogActions,
  LinearProgress,
  Button
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useParams } from 'react-router-dom';
import { Add as AddIcon } from '@material-ui/icons';

import Dialog from '../Dialog';
import AddRecord from '../EditCoursePanel/AddRecord';
import { inputFieldNames } from '../../constants';
import calculateNextEventDate from '../../mappers/calculateNextEventDate';
import { submitMode } from '../../constants';
import { addCourseRecordDialogOpenSource } from '../../constants';

const useStyles = makeStyles((theme) => ({
  dialog: {},
  dialogTitle: {
    background: '#f0f0f0'
  },
  dialogContent: {
    width: 580,
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(3)
  },
  actionButton: {
    width: 180,
    float: 'right',
    margin: theme.spacing(2)
  },
  footer: {
    background: '#f0f0f0'
  }
}));

const AddCourseRecordDialog = (props) => {
  const {
    openDialog,
    onOpenAddCourseRecordDialog,
    isSaving,
    record,
    onHandleInputChange,
    course,
    submitRecord,
    fetchAllPersonnels,
    personnels,
    courses,
    dialogOpenRequestSource,
    allAttachments,
    onRemoveAttachment,
    branchId
  } = props;

  const classes = useStyles();
  //let { branchId } = useParams();

  React.useEffect(() => {
    if (!personnels.length && openDialog === true) {
      fetchAllPersonnels(branchId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openDialog]); 

  const onDialogClose = () => {
    onOpenAddCourseRecordDialog(false);
  };

  const handleInputChange = (e, inputfieldName) => {
    if (
      inputfieldName === inputFieldNames.RECORD_DATE ||
      inputfieldName === inputFieldNames.COURSE_RECORD_ATTACHMENT
    ) {
      onHandleInputChange(e, inputfieldName);
    } else {
      onHandleInputChange(e.target.value, inputfieldName);
    }
  };

  const handleSubmitRecord = (e) => {
    e.preventDefault();

    const payload = {
      courseId: course.id,
      ...record,
      nextCourseDate: calculateNextEventDate(
        record.recordDate,
        course.frequency
      )
    };
    const source = 'dialog';
    submitRecord(payload, submitMode.CREATE, source, branchId);
  };

  const handleRemoveAttachment = (attachment) => {
    onRemoveAttachment(attachment);
  };

  return (
    <React.Fragment>
      <Dialog
        open={openDialog}
        onClose={onDialogClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={classes.dialog}
      >
        {isSaving ? <LinearProgress /> : ''}
        <DialogTitle id="alert-dialog-title" className={classes.dialogTitle}>
          Add Record
        </DialogTitle>
        <form onSubmit={handleSubmitRecord}>
          <DialogContent className={classes.dialogContent}>
            <AddRecord
              courses={courses}
              record={record}
              handleInputChange={handleInputChange}
              personnels={personnels}
              fetchAllPersonnels={fetchAllPersonnels}
              branchId={branchId}
              hideTitle={true}
              freezePersonnelList={
                dialogOpenRequestSource ===
                addCourseRecordDialogOpenSource.FROM_COURSES_FOR_PERSONNEL_DIALOG
              }
              showTrainingDropDown={
                dialogOpenRequestSource ===
                addCourseRecordDialogOpenSource.FROM_COURSES_FOR_PERSONNEL_DIALOG
              }
              showingInDialogBox={true}
              onDialogClose={onDialogClose}
              allAttachments={allAttachments}
              handleRemoveAttachment={handleRemoveAttachment}
            />
          </DialogContent>
          <DialogActions className={classes.footer}>
            <Button
              className={classes.actionButton}
              variant="outlined"
              onClick={onDialogClose}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              color="primary"
              className={classes.actionButton}
              variant="contained"
              startIcon={<AddIcon />}
            >
              Add
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </React.Fragment>
  );
};

export default AddCourseRecordDialog;
